import React from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useState } from 'react';
import { I18n } from 'utils/i18n';
import Employee from 'services/api/Employee';

const EmployeeSyncButton = ({ companyId, disabled = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleSync = async () => {
    setIsLoading(true);
    try {
      await Employee.sync(companyId);
      setSnackbar({
        open: true,
        message: I18n.t('CompanyDrawer.Employee sync successful'),
        severity: 'success',
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.data?.message || I18n.t('CompanyDrawer.Employee sync failed'),
        severity: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<SyncAltIcon />}
        onClick={handleSync}
        disabled={disabled || isLoading}
        sx={{ minWidth: 120 }}
      >
        {isLoading ? I18n.t('CompanyDrawer.Syncing...') : I18n.t('CompanyDrawer.Sync Employees')}
      </Button>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EmployeeSyncButton;
